import { auth } from '../../../firebase'

/**
 * Refreshes the Firebase authentication token and updates localStorage
 * Returns true if refresh was successful, false otherwise
 */
export const refreshAuthToken = async (): Promise<boolean> => {
  try {
    if (!auth.currentUser) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('No current user found, cannot refresh token')
      }
      return false
    }

    // Force refresh the token by passing true
    const newToken = await auth.currentUser.getIdToken(true)
    if (newToken) {
      localStorage.setItem('accessToken', newToken)
      localStorage.setItem('lastTokenRefresh', Date.now().toString())
      if (process.env.NODE_ENV === 'development') {
        console.log('Token refreshed successfully')
      }
      return true
    }
    return false
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to refresh token:', error)
    }
    return false
  }
}

/**
 * Sets up periodic token refresh during long-running operations
 * Refreshes token every 30 minutes (Firebase tokens expire after 1 hour, so refresh more frequently)
 * Returns a cleanup function to stop the interval
 */
export const setupTokenRefresh = (): (() => void) => {
  const REFRESH_INTERVAL_MS = 30 * 60 * 1000 // 30 minutes (more frequent to prevent expiration)

  // Refresh immediately to ensure we start with a fresh token
  refreshAuthToken()

  // Set up periodic refresh
  const intervalId = setInterval(() => {
    refreshAuthToken()
  }, REFRESH_INTERVAL_MS)

  // Return cleanup function
  return () => {
    clearInterval(intervalId)
  }
}
